export const formatRowsPDF = (listaItems) =>
  listaItems.map((item) => ({
    prd_code: item.prd_code,
    art_descripcion: item.cache_Art.art_descripcion,
    price: `$${item.ocd_price || 0}`,
    quantity: item.ocd_quantity || 0,
    observacion: item.ocd_observacion || "",
    total_amount: `$${item.ocd_total_amount || 0}`,
  }));

